import React, { useEffect, useRef, useState } from "react"
import s from "./GiftIdea.module.scss"
import gsap from "gsap"

export default function GiftIdea(props) {
  const giftIdea = useRef()
  const [finished, setFinished] = useState(false)

  useEffect(() => {
    const onComplete = () => {
      setFinished(true)
      tl.kill()
    }
    const tl = gsap.timeline({ onComplete })
    tl.fromTo(
      giftIdea.current,
      {
        yPercent: 250,
        autoAlpha: 0,
      },
      {
        yPercent: 100,
        autoAlpha: 1,
        duration: 0.5,
        ease: "none",
      }
    ).fromTo(
      giftIdea.current,
      {
        yPercent: 100,
        autoAlpha: 1,
      },
      {
        yPercent: 0,
        autoAlpha: 0,
        duration: 0.5,
      }
    )

    return () => tl.kill()
  }, [])

  if (finished) return <></>

  return (
    <>
      <div ref={giftIdea} className={s.giftIdea}>
        {/* <span>+</span>
        <span>Gift idea</span> */}
      </div>
    </>
  )
}
